/* eslint-disable max-len, no-nested-ternary, consistent-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, ButtonGroup, Button, Row, Col } from 'react-bootstrap';
import { isNil, isEmpty } from 'lodash';

import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';

import PageHeader from '../../atoms/PageHeader';
import AnnotationTemplatePreview from '../../components/AnnotationTemplatePreview';
import BlankState from '../../components/BlankState';
import NotFound from '../NotFound';

class ViewAnnotationTemplate extends Component {
  state = {
    previewMode: this.props.startingPreviewMode
  };

  changeToPreviewMode = () => {
    this.setState({ previewMode: 'preview' });
  };

  changeToEditionMode = () => {
    this.setState({ previewMode: 'edition' });
  };

  render() {
    const {
      annotationTemplate,
      selectedTemplate,
      updateAnnotationFields,
      trashAnnotationTemplate,
      history,
      match,
      readOnly
    } = this.props;
    const { previewMode } = this.state;
    if (selectedTemplate === '') {
      return <BlankState title="No template selected" subtitle="Please select a template" />;
    }
    if (selectedTemplate !== '' && isEmpty(annotationTemplate)) {
      return <NotFound />;
    }
    return (
      <>
        <Row>
          <Col xs={12}>
            <PageHeader>
              <h4 className="mr-auto">{templateOps.getName(annotationTemplate)}</h4>
              <ButtonToolbar>
                <ButtonGroup size="sm" className="mr-2">
                  <Button
                    onClick={this.changeToPreviewMode}
                    variant="info"
                    active={previewMode === 'preview'}
                  >
                    Preview
                  </Button>
                  <Button
                    onClick={this.changeToEditionMode}
                    active={previewMode === 'edition'}
                    variant="info"
                  >
                    Edition
                  </Button>
                </ButtonGroup>
                {!readOnly && (
                  <ButtonGroup size="sm">
                    <Button
                      onClick={() =>
                        history.push(`${match.url}/${templateOps.getId(annotationTemplate)}/edit`)
                      }
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => trashAnnotationTemplate(templateOps.getId(annotationTemplate))}
                      variant="danger"
                    >
                      Delete
                    </Button>
                  </ButtonGroup>
                )}
              </ButtonToolbar>
            </PageHeader>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <AnnotationTemplatePreview
              annotationTemplate={annotationTemplate}
              updateAnnotationFields={updateAnnotationFields}
              previewMode={previewMode}
              {...this.props}
            />
          </Col>
        </Row>
      </>
    );
  }
}

ViewAnnotationTemplate.defaultProps = {
  annotationTemplate: {},
  updateAnnotationFields: () => console.error('no action to update'),
  readOnly: false,
  startingPreviewMode: 'preview',
  trashAnnotationTemplate: () => console.error('no action to delete'),
  history: {},
  match: {}
};

ViewAnnotationTemplate.propTypes = {
  selectedTemplate: PropTypes.string.isRequired,
  annotationTemplate: PropTypes.object,
  updateAnnotationFields: PropTypes.func,
  readOnly: PropTypes.bool,
  startingPreviewMode: PropTypes.string,
  trashAnnotationTemplate(props, propName, componentName) {
    if (
      props.readOnly === false &&
      (isNil(props[propName]) || typeof props[propName] !== 'function')
    ) {
      return new Error(`Please provide a trashAnnotationTemplate function in ${componentName}!`);
    }
  },
  history(props, propName, componentName) {
    if (
      props.readOnly === false &&
      (isNil(props[propName]) || typeof props[propName] !== 'object')
    ) {
      return new Error(`Please provide a history object in ${componentName}!`);
    }
  },
  match(props, propName, componentName) {
    if (
      props.readOnly === false &&
      (isNil(props[propName]) || typeof props[propName] !== 'object')
    ) {
      return new Error(`Please provide a march object in ${componentName}!`);
    }
  }
};

export default ViewAnnotationTemplate;
